import React, { useState } from "react";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    honeypot: "", // 👈 hidden field
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🧠 simple anti-spam check
    if (formData.honeypot) {
      setStatus("⚠️ Spam detected.");
      return;
    }

    setStatus("Sending...");

    try {
      const res = await fetch(`${process.env.PUBLIC_URL}/email.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        setStatus("✅ Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
          honeypot: "",
        });
      } else {
        setStatus("❌ Failed to send message. Try again.");
      }
    } catch (error) {
      setStatus("⚠️ Error sending message. Please try again later.");
    }
  };

  return (
    <section className="container contact section" id="contact">
      <h2 className="section__title">Get In Touch</h2>

      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about everything!</h3>
          <p className="contact__details">
            Don't like forms? Send me an email.
          </p>
        </div>

        <form className="contact__form" onSubmit={handleSubmit}>
          {/* 🕵️ Hidden honeypot field */}
          <input
            type="text"
            name="honeypot"
            value={formData.honeypot}
            onChange={handleChange}
            style={{ display: "none" }}
            tabIndex="-1"
            autoComplete="off"
          />

          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="contact__form-input"
                placeholder="Your Name"
                required
              />
            </div>

            <div className="contact__form-div">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="contact__form-input"
                placeholder="Your Email"
                required
              />
            </div>
          </div>

          <div className="contact__form-div">
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="contact__form-input"
              placeholder="Subject"
              required
            />
          </div>

          <div className="contact__form-div contact__form-area">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              cols="30"
              rows="10"
              className="contact__form-input"
              placeholder="Write your message"
              required
            ></textarea>
          </div>

          <button className="btn" type="submit">
            Send Message
          </button>
          {status && <p className="contact__status">{status}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
